<div class="body" [ngClass]="profile">
  <header class="container relative">
    <div class="blub"></div>
    <div class="flex unflex-on-phone space-between">
      <a class="logo secondary-color light" routerLink="/">
        <img alt="Reveon Logo" src="assets/reveon_logo.svg">
      </a>
      <nav class="menu">
        <button class="btn horizontal vertical-on-phone secondary user mr28"
                *ngIf="service.isLoggedIn()"
                [matMenuTriggerFor]="myDataMenu">mijn gegevens</button>

        <a *ngIf="service.isUser()" href="https://www.reveon.nl/help/" target="_blank" class="btn horizontal vertical-on-phone magnify">help</a>

        <a href="https://reveon.nl"
           *ngIf="!service.isLoggedIn()"
           class="btn horizontal vertical-on-phone btn-light arrow-left">naar de website</a>

        <mat-menu #myDataMenu="matMenu" xPosition="before" class="my-data-menu">

          <ng-container *ngIf="service.isAdmin()">
            <button mat-menu-item routerLink="/overzichten/rapporten">
              <mat-icon>file_copy</mat-icon>
              <span>rapporten</span>
            </button>
            <button mat-menu-item routerLink="/overzichten/bewinden">
              <mat-icon>person</mat-icon>
              <span>bewinden</span>
            </button>
            <button mat-menu-item routerLink="/overzichten/facturen">
              <mat-icon>receipt</mat-icon>
              <span>facturen</span>
            </button>
            <button mat-menu-item routerLink="/regels">
              <mat-icon>rule</mat-icon>
              <span>regels</span>
            </button>
            <button mat-menu-item routerLink="/overzichten/taken">
              <mat-icon>toggle_on</mat-icon>
              <span>actieve users</span>
            </button>
          </ng-container>

          <ng-container *ngIf="service.isUser() && !service.isAdmin()">
            <button mat-menu-item routerLink="/account-gegevens-bewerken">
              <mat-icon>edit</mat-icon>
              <span>bewerken</span>
            </button>
            <button mat-menu-item routerLink="/facturen">
              <mat-icon>receipt</mat-icon>
              <span>facturen</span>
            </button>
          </ng-container>

          <button mat-menu-item (click)="logout()">
            <mat-icon>power_settings_new</mat-icon>
            <span>uitloggen</span>
          </button>
        </mat-menu>
      </nav>
    </div>
  </header>
  <main class="container" [attr.data-current-page]="currentPage">
    <div>
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<ngx-ui-loader></ngx-ui-loader>
